import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getColumnStatusMappingUrl } from '../../../../common/urls/index.tsx';
import {
	getIsCMPBoard,
	projectKeySelector,
	rapidViewIdSelector,
} from '../../../../state/selectors/software/software-selectors.tsx';
import { isSprintsEnabled } from '../../../../state/selectors/sprint/sprint-selectors.tsx';
import type { State } from '../../../../state/types.tsx';
import ColumnConfiguration from './view.tsx';

type StateProps = {
	isKanbanBoard: boolean;
	isCMPBoard: boolean;
	url: string;
};

const mapStateToProps = (state: State): StateProps => ({
	url: getColumnStatusMappingUrl(
		projectKeySelector(state),
		rapidViewIdSelector(state),
		getIsCMPBoard(state),
	),
	isKanbanBoard: !isSprintsEnabled(state),
	isCMPBoard: getIsCMPBoard(state),
});

const ConnectedColumnConfiguration = connect(mapStateToProps, {})(ColumnConfiguration);

export default ConnectedColumnConfiguration;
